import { Box, Skeleton, SkeletonText } from '@chakra-ui/react';

export const RDPSkeleton = (): JSX.Element => (
    <Box paddingX={{ base: 4, md: 12 }} paddingY={{ base: 12, md: 16 }} data-testid="rdp-skeleton">
        <Skeleton height="36px" width="70%" marginBottom={6} borderRadius="md" />
        <SkeletonText noOfLines={3} spacing={3} skeletonHeight="16px" />
    </Box>
);
